import { LotionPlusIcon } from './LotionPlusIcon';

/**
 * author: Google
 * id 74C0DC3D-4DE3-4E67-9100-0B59F2B9A6B2
 * name lotion-plus
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lotion-plus.svg
 * tags
 * - Medical / Hospital 
 */
export const HandSanitizerIcon = LotionPlusIcon;
export default HandSanitizerIcon